module.exports = __webpack_public_path__ + "public/img/jifenduihuan.d7cb11ed.png";